import { getLogger } from '@omnia/ui/src/lib'
import { getClubLevelById, loadMemberIfSignedIn } from '@vista-digital/occ-domain'

const logger = getLogger('membershipHelper').value

export const getMembershipTier = async (): Promise<string> => {
    try {
        const member = await loadMemberIfSignedIn()
        const clubLevelId = member?.clubMembership?.clubLevelId
        if (clubLevelId) {
            const clubLevel = getClubLevelById(clubLevelId)
            if (clubLevel) return clubLevel.name.text
        }
    } catch (e) {
        logger.error('Error loading membership tier:', e)
    }

    return 'None'
}
